const LOCAL_ADMIN_APP_URL = 'http://localhost:3002';
const LOCAL_PUBLIC_WEBSITE_URL = 'http://localhost:3033';
const PROD_ADMIN_APP_URL = 'https://admin.headstart.health';

interface ResolveAdminAppUrlOptions {
  configuredAdminUrl?: string;
  legacyConfiguredAppUrl?: string;
  isLocalDevelopment: boolean;
}

interface ResolvePublicWebsiteUrlOptions {
  configuredPublicWebsiteUrl?: string;
  isLocalDevelopment: boolean;
}

function parseConfiguredOrigin(
  value: string | undefined,
  variableName: string
): string | undefined {
  const normalizedValue = value?.trim();
  if (!normalizedValue) {
    return undefined;
  }

  let url: URL;
  try {
    url = new URL(normalizedValue);
  } catch {
    throw new Error(`${variableName} must be an absolute HTTP(S) URL`);
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    throw new Error(`${variableName} must be an absolute HTTP(S) URL`);
  }

  return url.origin;
}

export function resolveAdminAppUrl({
  configuredAdminUrl,
  legacyConfiguredAppUrl,
  isLocalDevelopment,
}: ResolveAdminAppUrlOptions): string {
  return (
    parseConfiguredOrigin(configuredAdminUrl, 'VITE_ADMIN_APP_URL') ??
    parseConfiguredOrigin(legacyConfiguredAppUrl, 'VITE_APP_URL') ??
    (isLocalDevelopment ? LOCAL_ADMIN_APP_URL : PROD_ADMIN_APP_URL)
  );
}

export function resolvePublicWebsiteUrl({
  configuredPublicWebsiteUrl,
  isLocalDevelopment,
}: ResolvePublicWebsiteUrlOptions): string {
  const configuredOrigin = parseConfiguredOrigin(
    configuredPublicWebsiteUrl,
    'VITE_PUBLIC_WEBSITE_URL'
  );
  if (configuredOrigin) {
    return configuredOrigin;
  }
  if (isLocalDevelopment) {
    return LOCAL_PUBLIC_WEBSITE_URL;
  }

  throw new Error('VITE_PUBLIC_WEBSITE_URL is required outside local development');
}
